import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Zone } from "../../zones/_types/zone";

export class WorkerZone extends Resource {
    public override type = 'workerZones';

    @prop()
    @required()
    public workerId?: string;

    @prop()
    public zoneId?: string;

    @propObject()
    public zone?: Zone;

    @prop()
    public value?: string;

    @prop()
    public normalServiceAllowed: boolean = false;

    @prop()
    public guardServiceAllowed: boolean = false;

    @prop()
    public excludedZipCodes?: string;

    @prop()
    public isTemporary: boolean = false;
}